import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import mixpanelPlugin from '@analytics/mixpanel';
import { isMixpanelAllowedEvent } from './mixpanelAllowlist';

declare const __ANALYTICS_MEASUREMENT_ID__: string;
declare const __MIXPANEL_TOKEN__: string;

const plugins = [
  googleAnalytics({
    measurementIds: [__ANALYTICS_MEASUREMENT_ID__],
    gtagName: 'gtagPlanneWidgets',
  }),
];

if (__MIXPANEL_TOKEN__) {
  const mixpanel = mixpanelPlugin({ token: __MIXPANEL_TOKEN__ });
  // Mixpanel shares this Analytics instance with Google Analytics, so by default every track()
  // reaches both. Gate the plugin's track to an allowlist: only approved events go to Mixpanel,
  // every other event keeps flowing to Google Analytics only.
  plugins.push({
    ...mixpanel,
    track: (args: { payload?: { event?: string } }) =>
      isMixpanelAllowedEvent(args?.payload?.event) ? mixpanel.track?.(args) : undefined,
  });
}

export const analytics = Analytics({
  app: 'planne-widgets',
  plugins,
});

export const track = (ev: string, data: any = null) => {
  analytics.track(ev, data);
};

export const identify = (id: string, data: any) => {
  analytics.identify(id, data);
};

export const reset = () => {
  analytics.reset();
};

export default {
  track,
  identify,
  reset,
  analytics,
};
